import React from "react";
import { Linkedin, Twitter, Youtube, Instagram } from "lucide-react";
import { BRAND, FOOTER_LINKS } from "../mock";

const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 bg-black">
      <div className="cga-container px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-white/95 p-1 flex items-center justify-center">
                <img
                  src={BRAND.logo}
                  alt={BRAND.name}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="leading-tight">
                <div className="text-white font-bold tracking-tight">
                  Coastal Growth
                </div>
                <div className="text-[10px] tracking-[0.22em] text-[#5eead4] uppercase">
                  Advisors
                </div>
              </div>
            </div>
            <p className="text-white/60 text-sm mt-5 max-w-sm leading-relaxed">
              {BRAND.tagline}
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Linkedin, Twitter, Youtube, Instagram].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 inline-flex items-center justify-center rounded-lg border border-white/10 text-white/70 hover:text-[#5eead4] hover:border-[#5eead4]/40 transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([title, items]) => (
            <div key={title}>
              <div className="text-white font-semibold text-sm mb-4">
                {title}
              </div>
              <ul className="space-y-2.5">
                {items.map((item) => (
                  <li key={item}>
                    <a
                      href="#"
                      className="text-white/60 hover:text-[#5eead4] text-sm transition-colors"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} Coastal Growth Advisors. All rights
            reserved.
          </p>
          <p className="text-white/40 text-xs">
            Built for businesses that want to scale.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
